"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('dribble', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("circle", {
    cx: "24",
    cy: "24",
    r: "20",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth
  }), _react.default.createElement("path", {
    d: "M4.5 21.5C8.27778 21.7278 17.9333 21.9332 24.3333 19.1999C30.7333 16.4666 36.1111 11.5944 38 10",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M16.5 5.5C19.6304 8.38889 26.4603 15.6985 29 23C31.5397 30.3015 32.4203 38.9444 33 41.5",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M10 38C12.4694 34.6842 18 29.5 25.8265 26.063C33.0312 22.8992 41.0816 23.9996 44 23.9996",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;